import axios from 'axios';
var Cookies = require("js-cookie")

const api = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT_HTTP
});

console.log("API: " + process.env.REACT_APP_API_ENDPOINT_HTTP);
console.log("PROCESS ENV: " + JSON.stringify(process.env));

api.interceptors.request.use((config) => {
    if (Cookies.get("token")) {
        const AUTH_TOKEN = Cookies.get("token")
        config.headers.Authorization = `Bearer ${AUTH_TOKEN}`;
    }

    return config;
})

export default api;